import { Autocomplete, TextField } from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { Subject } from 'rxjs';
import { debounceTime, tap } from 'rxjs/operators';
import { RootState } from '../../store';
import { ProductSearchResult, searchProduct, selectProduct } from './redux/calculationSlices';

const mapStateToProps = (state: RootState) => ({
    productSearchResult: state.calculation.productSearchResult
});
type Props = ReturnType<typeof mapStateToProps>;

const inputChangedSubject = new Subject<string | undefined>();

const onInputChanged = (val: string | undefined) => {
    inputChangedSubject.next(val);
};

const SelectArticle = ({ productSearchResult }: Props) => {
    const dispatch = useDispatch();

    const [inputValue, setInputValue] = useState('' as string | undefined);

    useEffect(() => {
        const subscription = inputChangedSubject
            .pipe(
                tap(val => setInputValue(val)),
                debounceTime(200)
            )
            .subscribe(value => {
                if (value !== '') {
                    dispatch(searchProduct.request(value));
                }
            });

        // Important to unsubscribe on teardown so we don't create a memory leak
        return () => subscription.unsubscribe();
    }, [dispatch]);

    const selectArticle = useCallback(
        (value: ProductSearchResult | null) => {
            if (value != null) {
                dispatch(selectProduct(value));
            } else {
                dispatch(selectProduct(null));
            }
        },
        [dispatch]
    );

    return (
        <div>
            <Autocomplete
                id="combo-box-demo"
                options={productSearchResult}
                clearOnEscape={true}
                getOptionLabel={product => `${product?.productId} ${product?.name}`}
                style={{ width: 300 }}
                onChange={(_, value) => selectArticle(value)}
                disableClearable
                inputValue={inputValue}
                onInputChange={(event, newInputValue) => {
                    onInputChanged(newInputValue);
                }}
                renderInput={params => (
                    <TextField
                        {...params}
                        label="Article"
                        variant="outlined"
                        aria-label="Article"
                        InputProps={{ ...params.InputProps, type: 'search' }}
                    />
                )}
            />
        </div>
    );
};

export default connect(mapStateToProps)(SelectArticle);
